import dayjs from 'dayjs';

import { ValueStub } from 'constants/data';
import { COMMON_DATE_FORMAT } from 'constants/date';

export const getAddedMetaLabel = ({ addedBy, addedDate }) => {
  const author = addedBy && addedBy !== ValueStub.ALTERNATE ? addedBy : null;
  const date = addedDate ? dayjs(addedDate).format(COMMON_DATE_FORMAT) : null;

  if (author && date) {
    return `Added by ${author} · ${date}`;
  }

  if (author) {
    return `Added by ${author}`;
  }

  if (date) {
    return `Added ${date}`;
  }

  return null;
};
